<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title>Baixando arquivo...</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingDetalhesDialog" persistent max-width="400">
      <v-card>
        <v-card-title>Carregando detalhes...</v-card-title>

        <v-card-text>
          <v-progress-linear
            indeterminate
            color="primary"
            height="6"
            rounded
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-email-multiple"
            title="Mensageria em Lote"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <div class="form-label">
                    <span>Empresa</span>
                    <span class="form-label__required">*</span>
                  </div>
                  <v-select
                    v-model="mensagem.empresa"
                    :items="empresasDisponiveis"
                    label="Selecionar empresa"
                    dense
                    solo-inverted
                    required
                    :rules="[(v) => !!v || 'Este campo e obrigatorio']"
                    @change="handleEmpresaChange"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="4" class="py-0">
                  <div class="form-label">
                    <span>Titulo</span>
                    <span class="form-label__required">*</span>
                  </div>
                  <v-text-field
                    v-model="mensagem.titulo"
                    label="Titulo do disparo"
                    dense
                    solo-inverted
                    required
                    counter="100"
                    maxlength="100"
                    :rules="[
                      (v) => !!v || 'Este campo e obrigatorio',
                      (v) =>
                        (v && v.length <= 100) || 'Maximo de 100 caracteres',
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="2" class="py-0">
                  <div class="form-label">
                    <span>Template</span>
                    <span class="form-label__required">*</span>
                  </div>
                  <v-select
                    v-model="selectedTemplateId"
                    :items="activeTemplates"
                    item-text="name"
                    item-value="_id"
                    label="Selecionar template"
                    dense
                    solo-inverted
                    :readonly="loadingTemplates"
                    :loading="loadingTemplates"
                    :disabled="!mensagem.empresa"
                    required
                    :rules="[(v) => !!v || 'Este campo e obrigatorio']"
                    @change="onTemplateSelectChange"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="2" class="py-0">
                  <div class="form-label">
                    <span>Data Inicial</span>
                    <span class="form-label__required">*</span>
                  </div>
                  <v-menu
                    v-model="isDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="mensagem.dataEnvio"
                        label="Data Inicial"
                        dense
                        solo-inverted
                        readonly
                        required
                        :rules="[
                          (v) =>
                            (v != null && v !== '') ||
                            'Este campo e obrigatorio',
                        ]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="localSelectedDateISO"
                      no-title
                      @input="handleDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <div class="form-label">
                    <span>Horario</span>
                    <span class="form-label__required">*</span>
                  </div>
                  <v-text-field
                    v-model="mensagem.horarioEnvio"
                    label="Horario"
                    type="time"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Este campo e obrigatorio']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0 d-flex align-end">
                  <v-chip
                    v-if="mensagem.empresa"
                    small
                    color="rgb(231 244 255)"
                    text-color="#3055a4"
                    class="mb-5"
                  >
                    Número disparo: {{ telefoneEmpresa || "Nao mapeado" }}
                  </v-chip>
                </v-col>
              </v-row>

              <v-row>
                <template v-if="selectedTemplate">
                  <v-col cols="12" class="py-0">
                    <span>Pre-visualizacao do template</span>
                    <v-sheet
                      outlined
                      rounded
                      class="pa-4 mb-3 template-preview-sheet"
                    >
                      <div class="text--secondary text-caption mb-2">
                        O conteudo abaixo e atualizado conforme os parametros
                        sao preenchidos.
                      </div>
                      <div class="template-preview-text">
                        {{ getTemplatePreview(selectedTemplate.content) }}
                      </div>
                    </v-sheet>
                  </v-col>

                  <v-col
                    cols="12"
                    class="py-0"
                    v-if="getTemplateParamsDetalhes(mensagemSelecionada).length"
                  >
                    <span>Parametros do template</span>
                  </v-col>

                  <v-col
                    v-for="(param, index) in extractTemplateParams(
                      selectedTemplate.content,
                    )"
                    :key="`${selectedTemplateId}-${param}-${index}`"
                    cols="12"
                    sm="6"
                    md="4"
                    class="py-0"
                  >
                    <v-text-field
                      v-model="templateParams[index]"
                      :label="
                        templateParamLabels[index] || `Parametro ${index + 1}`
                      "
                      dense
                      solo-inverted
                      required
                      :rules="[(v) => !!v || 'Este campo e obrigatorio']"
                    ></v-text-field>
                  </v-col>
                </template>

                <v-col cols="12" sm="12" class="py-0">
                  <div class="d-flex align-center">
                    <div class="form-label mb-0">
                      <span>Clientes para realizar o envio</span>
                      <span class="form-label__required">*</span>
                    </div>
                    <v-btn
                      color="grey"
                      small
                      text
                      @click="dialogInfoArquivo = true"
                    >
                      <v-icon>mdi-information</v-icon>
                    </v-btn>
                  </div>
                  <v-file-input
                    v-model="arquivoExcel"
                    label="Selecionar arquivo Excel"
                    accept=".xls,.xlsx"
                    dense
                    solo-inverted
                    class="mensageria-lote-file-input"
                    prepend-icon="mdi-file-excel"
                    prepend-icon-color="green"
                    show-size
                    counter
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  >
                  </v-file-input>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Status</span>
                  <v-switch
                    v-model="mensagem.status"
                    :label="mensagem.status ? 'Ativo' : 'Inativo'"
                    color="primary"
                    hide-details
                    class="mt-2"
                    inset
                  ></v-switch>
                </v-col>

                <v-col cols="12" sm="6" md="4" class="py-0">
                  <div class="d-flex align-center">
                    <span>Finalizar protocolos automaticamente</span>
                    <v-btn
                      color="grey"
                      small
                      text
                      @click="dialogInfoFinalizarProtocolo = true"
                    >
                      <v-icon class="info-icon">mdi-information</v-icon>
                    </v-btn>
                  </div>
                  <v-switch
                    v-model="mensagem.finalizarProtocolos"
                    :label="mensagem.finalizarProtocolos ? 'Sim' : 'Nao'"
                    color="primary"
                    hide-details
                    class="mt-2"
                    inset
                  ></v-switch>
                </v-col>

                <v-col cols="12" class="py-4 d-flex justify-end">
                  <v-btn
                    outlined
                    small
                    color="primary"
                    class="mr-4"
                    @click="limparFormulario"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    Limpar formulario
                  </v-btn>

                  <v-btn
                    small
                    color="primary"
                    :loading="loadingCreate"
                    :disabled="!valid || !allParametersFilled"
                    @click="enviarMensagemLote"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Novo disparo
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-dialog v-model="dialogInfoArquivo" max-width="800px">
              <v-card>
                <v-card-title>
                  <v-icon left>mdi-information</v-icon>
                  Informacoes sobre o arquivo Excel
                </v-card-title>
                <v-card-text>
                  <v-alert
                    type="info"
                    class="mt-4"
                    border="left"
                    colored-border
                  >
                    <strong>Estrutura do Arquivo Excel:</strong><br />
                    • <strong>Coluna A:</strong> Telefone (obrigatorio)<br />
                    • <strong>Coluna B:</strong> Nome (opcional)<br />
                    • <strong>Coluna C:</strong> Identificacao (opcional)<br /><br />
                    <strong>Exemplo:</strong><br />
                    Telefone | Nome | Identificacao |<br />
                    82999999999 | Joao Silva | PV00123 |
                  </v-alert>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    small
                    @click="dialogInfoArquivo = false"
                  >
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogInfoFinalizarProtocolo" max-width="560px">
              <v-card>
                <v-card-title>
                  <v-icon left color="green darken-2">mdi-information</v-icon>
                  Finalizacao automatica de protocolo
                </v-card-title>
                <v-card-text>
                  <v-alert
                    type="info"
                    class="mt-4 mb-0"
                    border="left"
                    colored-border
                  >
                    Ao realizar o envio, será gerado um protocolo. Se esta opção
                    estiver marcada, o protocolo será finalizado automaticamente
                    e não permanecerá aberto na fila de atendimentos da unidade.
                  </v-alert>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    small
                    @click="dialogInfoFinalizarProtocolo = false"
                  >
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-divider class="my-6"></v-divider>

            <v-row align="center" class="mb-4">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="searchTitulo"
                  label="Buscar por título"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="filtroEmpresa"
                  :items="empresasDisponiveis"
                  label="Filtrar por empresa"
                  prepend-inner-icon="mdi-office-building"
                  dense
                  outlined
                  clearable
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="filtroStatusEnvio"
                  :items="opcoesStatusEnvio"
                  label="Filtrar por status do envio"
                  prepend-inner-icon="mdi-filter-variant"
                  dense
                  outlined
                  clearable
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="d-flex justify-end">
                <v-btn
                  color="primary"
                  outlined
                  :loading="loadingLista"
                  @click="carregarLista"
                  small
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Atualizar
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="mensagensFiltradas"
                  :loading="loadingLista"
                  :no-data-text="'Nenhuma mensagem em lote encontrada'"
                  :no-results-text="'Nenhum resultado encontrado'"
                  class="elevation-0"
                >
                  <template v-slot:item.templateNome="{ item }">
                    <div class="text-truncate" style="max-width: 220px">
                      {{
                        item.templateNome ||
                        item.nomeTemplate ||
                        item.templateId ||
                        "-"
                      }}
                    </div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status ? 'green lighten-5' : 'red lighten-5'"
                      :text-color="
                        item.status ? 'green darken-3' : 'red darken-3'
                      "
                      small
                    >
                      {{ item.status ? "Ativo" : "Inativo" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.statusEnvio="{ item }">
                    <v-chip
                      :color="getStatusEnvioColor(getStatusEnvioValue(item))"
                      :text-color="
                        getStatusEnvioTextColor(getStatusEnvioValue(item))
                      "
                      small
                    >
                      {{ getStatusEnvioLabel(item) }}
                    </v-chip>
                  </template>

                  <template v-slot:item.acoes="{ item }">
                    <div class="mensageria-lote-actions">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="primary"
                            small
                            class="mensageria-lote-action-btn"
                            v-on="on"
                            @click="visualizarDetalhes(item)"
                          >
                            <v-icon small>mdi-eye-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver detalhes</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            :color="item.status ? 'red' : 'green'"
                            outlined
                            small
                            class="mensageria-lote-action-btn"
                            v-on="on"
                            @click="alterarStatus(item)"
                          >
                            <v-icon small>{{
                              item.status ? "mdi-pause" : "mdi-play"
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                          item.status ? "Desativar lote" : "Ativar lote"
                        }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogDetalhes" max-width="860px" persistent>
        <v-card>
          <v-card-title class="py-2">
            <span class="font-weight-medium">
              Mensageria em Lote #{{ mensagemSelecionada.id || "-" }}
            </span>
            <v-spacer></v-spacer>
            <v-chip
              :color="
                mensagemSelecionada.status ? 'green lighten-5' : 'red lighten-5'
              "
              :text-color="
                mensagemSelecionada.status ? 'green darken-3' : 'red darken-3'
              "
              small
              class="mr-2"
            >
              {{ mensagemSelecionada.status ? "Ativo" : "Inativo" }}
            </v-chip>
            <v-chip
              :color="
                getStatusEnvioColor(getStatusEnvioValue(mensagemSelecionada))
              "
              :text-color="
                getStatusEnvioTextColor(
                  getStatusEnvioValue(mensagemSelecionada),
                )
              "
              small
            >
              {{ getStatusEnvioLabel(mensagemSelecionada) }}
            </v-chip>
          </v-card-title>

          <v-card-subtitle class="py-0">
            <v-icon small class="mr-1">mdi-calendar</v-icon>
            {{ mensagemSelecionada.dataEnvio || "-" }}
            <v-icon small class="mx-2">mdi-clock-time-four-outline</v-icon>
            {{ mensagemSelecionada.horarioEnvio || "-" }}
            <v-icon small class="mx-2">mdi-account-group</v-icon>
            {{ quantidadeClientes(mensagemSelecionada) }} clientes
          </v-card-subtitle>

          <v-divider class="my-2"></v-divider>

          <v-card-text class="pt-0">
            <v-row dense>
              <v-col cols="6" md="4">
                <div class="text--secondary text-caption mb-1">Empresa</div>
                <v-text-field
                  :value="mensagemSelecionada.empresa || '-'"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="6" md="4">
                <div class="text--secondary text-caption mb-1">Status</div>
                <v-text-field
                  :value="mensagemSelecionada.status ? 'Ativo' : 'Inativo'"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="6" md="4">
                <div class="text--secondary text-caption mb-1">
                  Finalizar protocolos
                </div>
                <v-text-field
                  :value="
                    mensagemSelecionada.finalizarProtocolos ? 'Sim' : 'Nao'
                  "
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-expansion-panels class="mb-3" accordion>
                <v-expansion-panel class="expansion-panel">
                  <v-expansion-panel-header>
                    <v-icon left small>mdi-text-box-outline</v-icon>
                    Template enviado
                    <span class="ml-2 grey--text text--darken-1">
                      ({{
                        mensagemSelecionada.templateNome ||
                        mensagemSelecionada.nomeTemplate ||
                        mensagemSelecionada.templateId ||
                        "-"
                      }})
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="text--secondary text-caption mb-2">
                      View do template
                    </div>

                    <div
                      v-if="loadingTemplateDetalhes"
                      class="resumo-status-placeholder"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>

                    <v-alert
                      v-else-if="!templateDetalhesContent"
                      type="info"
                      border="left"
                      colored-border
                      dense
                      class="mb-3"
                    >
                      Nao foi possivel carregar o conteudo do template enviado.
                    </v-alert>

                    <v-sheet
                      v-else
                      outlined
                      rounded
                      class="pa-4 mb-4 template-preview-sheet"
                    >
                      <div class="template-preview-text">
                        {{ getTemplateViewDetalhes(mensagemSelecionada) }}
                      </div>
                    </v-sheet>

                    <div
                      class="text--secondary text-caption mb-2"
                      v-if="
                        getTemplateParamsDetalhes(mensagemSelecionada).length
                      "
                    >
                      Parametros do template
                    </div>

                    <v-sheet
                      outlined
                      rounded
                      class="pa-3"
                      v-if="
                        getTemplateParamsDetalhes(mensagemSelecionada).length
                      "
                    >
                      <div class="d-flex flex-wrap">
                        <v-chip
                          v-for="(param, index) in getTemplateParamsDetalhes(
                            mensagemSelecionada,
                          )"
                          :key="`param-${index}`"
                          small
                          color="rgb(231 244 255)"
                          text-color="#3055a4"
                          class="mr-2 mb-2"
                        >
                          Parametro {{ index + 1 }}: {{ param }}
                        </v-chip>
                      </div>
                    </v-sheet>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-col cols="12">
                <v-card outlined class="resumo-status-card">
                  <v-card-title class="py-3">
                    <v-icon left small>mdi-chart-pie</v-icon>
                    Resumo do Envio
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-4">
                    <v-row dense align="center">
                      <v-col cols="12" md="7">
                        <div
                          v-if="loadingResumoStatus"
                          class="resumo-status-placeholder"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </div>

                        <v-alert
                          v-else-if="!resumoStatusTemDados"
                          type="info"
                          border="left"
                          colored-border
                          dense
                          class="mb-0"
                        >
                          Nenhum status consolidado encontrado para este lote.
                        </v-alert>

                        <apexcharts
                          v-else
                          type="pie"
                          height="320"
                          :options="
                            generatePieChartOptions(
                              resumoStatusGraficoLabels,
                              resumoStatusItens.map((item) => item.color),
                            )
                          "
                          :series="resumoStatusGraficoSeries"
                        ></apexcharts>
                      </v-col>

                      <v-col cols="12" md="5">
                        <v-sheet outlined rounded class="pa-3">
                          <div class="text--secondary text-caption mb-3">
                            Totais consolidados
                          </div>

                          <div class="resumo-status-total mb-3">
                            <span>Total de clientes</span>
                            <strong>{{
                              resumoStatus.totalClientes || 0
                            }}</strong>
                          </div>

                          <div
                            v-for="item in resumoStatusItens"
                            :key="item.label"
                            class="resumo-status-item"
                          >
                            <div class="d-flex align-center">
                              <span
                                class="resumo-status-dot"
                                :style="{ backgroundColor: item.color }"
                              ></span>
                              <span>{{ item.label }}</span>
                            </div>
                            <strong>{{ item.value }}</strong>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-expansion-panels class="mt-3" accordion>
              <v-expansion-panel class="expansion-panel">
                <v-expansion-panel-header>
                  <v-icon left small>mdi-account-group</v-icon>
                  Lista de Clientes
                  <span class="ml-2 grey--text text--darken-1">
                    ({{ quantidadeClientes(mensagemSelecionada) }})
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    v-if="
                      mensagemSelecionada.composicoes &&
                      mensagemSelecionada.composicoes.length
                    "
                    dense
                    :headers="headersComposicoes"
                    :items="mensagemSelecionada.composicoes"
                    :items-per-page="8"
                    class="elevation-0"
                    :footer-props="{ itemsPerPageOptions: [8, 16, 32] }"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="getStatusEnvioColor(item.status)"
                        :text-color="getStatusEnvioTextColor(item.status)"
                        x-small
                      >
                        {{ item.status }}
                      </v-chip>
                    </template>
                  </v-data-table>

                  <v-alert
                    v-else
                    type="info"
                    border="left"
                    colored-border
                    dense
                    class="mb-0"
                  >
                    Nenhum cliente encontrado para esta mensagem.
                  </v-alert>
                  <div
                    v-if="
                      mensagemSelecionada.composicoes &&
                      mensagemSelecionada.composicoes.length
                    "
                    class="d-flex justify-end"
                  >
                    <div style="width: 60px; text-align: end">
                      <span
                        @click="downloadExcelComposicao(mensagemSelecionada.id)"
                        style="
                          color: green;
                          font-size: 28px;
                          margin-right: 12px;
                          cursor: pointer;
                        "
                        title="Baixar Excel"
                      >
                        <i class="fas fa-file-excel"></i>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="py-2">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDetalhes = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAviso" max-width="400px" persistent>
        <v-card>
          <v-card-title
            class="headline"
            :class="avisoConfig.color + ' white--text'"
          >
            <v-icon left>{{ avisoConfig.icon }}</v-icon>
            {{ avisoConfig.title }}
          </v-card-title>
          <v-card-text class="pt-4">
            {{ avisoConfig.message }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="avisoConfig.color" text @click="dialogAviso = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import mensageria from "../../services/mensageria";
import SonaxService from "@/services/sonax";
import downloadBlob from "@/services/downloadBlob";
import VueApexCharts from "vue-apexcharts";

const EMPRESAS_DISPONIVEIS = [
  "Previda",
  "Memorial Parque Maceio",
  "Parque das Flores",
  "Parque do Agreste",
  "Cemiterio Previda",
  "Cemiterio Previda Sao Miguel",
];

export default {
  name: "MensageriaLote",
  components: {
    apexcharts: VueApexCharts,
  },

  data() {
    return {
      dialogInfoArquivo: false,
      dialogInfoFinalizarProtocolo: false,
      dialogDetalhes: false,
      dialogAviso: false,
      showProgress: false,
      loadingDetalhesDialog: false,
      valid: false,
      loadingCreate: false,
      loadingLista: false,
      loadingTemplates: false,
      loadingResumoStatus: false,
      isDatePickerOpen: false,
      localSelectedDateISO: "",
      arquivoExcel: null,
      listaMensagensLote: [],
      templates: [],
      selectedTemplate: null,
      selectedTemplateId: null,
      templateParams: [],
      templateParamLabels: [],
      mensagemSelecionada: {},
      templateDetalhesContent: "",
      loadingTemplateDetalhes: false,
      resumoStatus: {
        totalClientes: 0,
        totalPendentes: 0,
        totalEnviadas: 0,
        totalEntregues: 0,
        totalLidas: 0,
        totalErro: 0,
      },
      avisoConfig: {
        title: "",
        message: "",
        color: "primary",
        icon: "mdi-information",
      },
      searchTitulo: "",
      filtroEmpresa: null,
      filtroStatusEnvio: null,
      opcoesStatusEnvio: [
        { text: "Agendado", value: "AGENDADO" },
        { text: "Enviado", value: "ENVIADO" },
        { text: "Inativo", value: "INATIVO" },
        { text: "Enviado Parcial", value: "ENVIADO_PARCIAL" },
      ],
      mensagem: {
        empresa: null,
        titulo: "",
        dataEnvio: "",
        horarioEnvio: "12:00",
        status: true,
        finalizarProtocolos: true,
      },
      headers: [
        { text: "#", value: "id", width: "40px" },
        { text: "Título", value: "titulo", width: "200px" },
        { text: "Data de Envio", value: "dataEnvio", width: "140px" },
        { text: "Horario", value: "horarioEnvio", width: "110px" },
        { text: "Empresa", value: "empresa", width: "180px" },
        { text: "Template", value: "templateNome", width: "220px" },
        { text: "Status", value: "status", width: "110px" },
        { text: "Status do envio", value: "statusEnvio", width: "150px" },
        { text: "Clientes", value: "quantidadeClientes", width: "110px" },
        {
          text: "Acoes",
          value: "acoes",
          width: "150px",
          sortable: false,
          align: "center",
        },
      ],
      headersComposicoes: [
        { text: "ID", value: "id", width: "80px" },
        { text: "Status", value: "status", width: "120px" },
        { text: "Telefone", value: "telefone", width: "150px" },
        { text: "Nome", value: "nome" },
        { text: "Identificacao", value: "identificacao", width: "150px" },
      ],
    };
  },

  computed: {
    empresasDisponiveis() {
      return EMPRESAS_DISPONIVEIS;
    },

    telefoneEmpresa() {
      return this.getTelefoneEmpresa(this.mensagem.empresa);
    },

    activeTemplates() {
      if (!this.templates || !this.templates.length) {
        return [];
      }

      return this.templates.filter(
        (template) =>
          template.status_cliente === "ATIVO" &&
          template.status_broker === "APPROVED",
      );
    },

    allParametersFilled() {
      if (!this.selectedTemplate) {
        return false;
      }

      const params = this.extractTemplateParams(this.selectedTemplate.content);

      if (!params.length) {
        return true;
      }

      return this.templateParams.every((param, index) => {
        return (
          index >= params.length || (param && param.toString().trim() !== "")
        );
      });
    },

    mensagensFiltradas() {
      let mensagens = this.listaMensagensLote || [];

      // Filtrar por título
      if (this.searchTitulo) {
        const searchNormalizado = this.normalizarTexto(this.searchTitulo);
        mensagens = mensagens.filter((item) => {
          const tituloNormalizado = this.normalizarTexto(item.titulo || "");
          return tituloNormalizado.includes(searchNormalizado);
        });
      }

      // Filtrar por empresa
      if (this.filtroEmpresa) {
        mensagens = mensagens.filter((item) => {
          const empresaNormalizada = this.normalizarTexto(item.empresa || "");
          const filtroNormalizado = this.normalizarTexto(this.filtroEmpresa);
          return empresaNormalizada === filtroNormalizado;
        });
      }

      // Filtrar por status do envio
      if (this.filtroStatusEnvio) {
        mensagens = mensagens.filter((item) => {
          const statusEnvio = this.getStatusEnvioValue(item);
          return statusEnvio === this.filtroStatusEnvio;
        });
      }

      return mensagens;
    },

    resumoStatusGraficoLabels() {
      return ["Pendentes", "Enviadas", "Entregues", "Lidas", "Erro"];
    },

    resumoStatusGraficoSeries() {
      return [
        Number(this.resumoStatus.totalPendentes || 0),
        Number(this.resumoStatus.totalEnviadas || 0),
        Number(this.resumoStatus.totalEntregues || 0),
        Number(this.resumoStatus.totalLidas || 0),
        Number(this.resumoStatus.totalErro || 0),
      ];
    },

    resumoStatusTemDados() {
      return this.resumoStatusGraficoSeries.some((valor) => Number(valor) > 0);
    },

    resumoStatusItens() {
      return [
        {
          label: "Pendentes",
          value: Number(this.resumoStatus.totalPendentes || 0),
          color: "#90A4AE",
        },
        {
          label: "Enviadas",
          value: Number(this.resumoStatus.totalEnviadas || 0),
          color: "#42A5F5",
        },
        {
          label: "Entregues",
          value: Number(this.resumoStatus.totalEntregues || 0),
          color: "#26A69A",
        },
        {
          label: "Lidas",
          value: Number(this.resumoStatus.totalLidas || 0),
          color: "#66BB6A",
        },
        {
          label: "Erro",
          value: Number(this.resumoStatus.totalErro || 0),
          color: "#EF5350",
        },
      ];
    },
  },

  mounted() {
    this.inicializarData();
    this.carregarLista();
  },

  methods: {
    async downloadExcelComposicao(id) {
      if (!id) {
        this.mostrarAviso(
          "Aviso",
          "Nao foi possivel identificar o lote para baixar o Excel.",
          "warning",
        );
        return;
      }
      this.showProgress = true;
      try {
        const response = await mensageria.downloadExcelComposicao(id);
        const contentDisposition =
          response.headers?.["content-disposition"] || "";
        const fileNameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i,
        );
        const fileName = fileNameMatch
          ? fileNameMatch[1].replace(/['"]/g, "")
          : `mensageria-em-lote-${id}-clientes.xlsx`;

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        downloadBlob(blob, fileName);
      } catch (error) {
        console.error("Erro ao baixar Excel da composicao:", error);
        this.mostrarAviso(
          "Erro!",
          "Nao foi possivel baixar o Excel da composicao.",
          "error",
        );
      } finally {
        this.showProgress = false;
      }
    },
    normalizarTexto(valor) {
      return (valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
    },

    filtrarPorTitulo(value, search, item) {
      if (!search) return true;

      const searchNormalizado = this.normalizarTexto(search);
      const tituloNormalizado = this.normalizarTexto(item.titulo || "");

      return tituloNormalizado.includes(searchNormalizado);
    },

    getTelefoneEmpresa(empresa) {
      if (!empresa) {
        return null;
      }

      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "PARQUE DAS FLORES": "558296411028",
        "PARQUE DO AGRESTE": "558000829000",
        "CEMITERIO PREVIDA": "558000829000",
        "CEMITERIO PREVIDA SAO MIGUEL": "558000829000",
      };

      const empresaNormalizada = this.normalizarTexto(empresa);

      return mapeamentoEmpresas[empresaNormalizada] || null;
    },

    inicializarData() {
      const hoje = new Date();
      const dataFormatada = hoje.toISOString().split("T")[0];
      this.localSelectedDateISO = dataFormatada;
      this.mensagem.dataEnvio = this.formatarDataBR(dataFormatada);
    },

    handleDateSelection() {
      this.mensagem.dataEnvio = this.formatarDataBR(this.localSelectedDateISO);
      this.isDatePickerOpen = false;
    },

    formatarDataBR(dataISO) {
      const [ano, mes, dia] = dataISO.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    quantidadeClientes(item) {
      if (item.quantidadeClientes != null) {
        return item.quantidadeClientes;
      }

      return item.composicoes ? item.composicoes.length : 0;
    },

    getStatusEnvioValue(item) {
      return (
        item.statusEnvio ||
        item.status_disparo ||
        item.situacaoEnvio ||
        item.situacao ||
        "Agendado"
      );
    },

    getStatusEnvioLabel(item) {
      let status = this.getStatusEnvioValue(item);
      if (status === "ENVIADO_PARCIAL") status = "ENVIADO PARCIAL";
      return status || "Agendado";
    },

    getStatusEnvioColor(status) {
      const valor = this.normalizarTexto(status);

      if (valor.includes("ENVIADO") || valor.includes("SUCESSO")) {
        return "green lighten-5";
      }

      if (valor.includes("ERRO") || valor.includes("FALHA")) {
        return "red lighten-5";
      }

      if (valor.includes("CANCELADO")) {
        return "grey lighten-3";
      }

      return "blue lighten-5";
    },

    getStatusEnvioTextColor(status) {
      const valor = this.normalizarTexto(status);

      if (valor.includes("ENVIADO") || valor.includes("SUCESSO")) {
        return "green darken-3";
      }

      if (valor.includes("ERRO") || valor.includes("FALHA")) {
        return "red darken-3";
      }

      if (valor.includes("CANCELADO")) {
        return "grey darken-3";
      }

      return "blue darken-3";
    },

    getTemplateParamsDetalhes(item) {
      if (Array.isArray(item.templateParams)) {
        return item.templateParams;
      }

      if (Array.isArray(item.parametrosTemplate)) {
        return item.parametrosTemplate;
      }

      if (typeof item.templateParams === "string" && item.templateParams) {
        return item.templateParams.split(";").filter(Boolean);
      }

      return [];
    },

    async handleEmpresaChange() {
      this.templates = [];
      this.selectedTemplate = null;
      this.selectedTemplateId = null;
      this.templateParams = [];
      this.templateParamLabels = [];

      if (!this.mensagem.empresa) {
        return;
      }

      if (!this.telefoneEmpresa) {
        this.mostrarAviso(
          "Aviso",
          "A empresa selecionada nao possui telefone mapeado para buscar templates.",
          "warning",
        );
        return;
      }

      await this.fetchTemplates();
    },

    async fetchTemplates() {
      if (!this.mensagem.empresa || !this.telefoneEmpresa) {
        return;
      }

      this.loadingTemplates = true;

      try {
        const response = await SonaxService.getTemplates(this.telefoneEmpresa);
        const brokers = response.data?.data?.brokers || [];

        let brokerEncontrado = brokers.find(
          (broker) =>
            broker.number === this.telefoneEmpresa &&
            broker.templates &&
            broker.templates.length,
        );

        if (!brokerEncontrado) {
          brokerEncontrado = brokers.find(
            (broker) => broker.templates && broker.templates.length,
          );
        }

        if (brokerEncontrado && brokerEncontrado.templates) {
          const brokerNumber = brokerEncontrado.number;
          this.templates = brokerEncontrado.templates.map((template) => ({
            ...template,
            brokerNumber,
          }));
          return;
        }

        this.templates = [];
      } catch (error) {
        console.error("Erro ao buscar templates:", error);
        this.templates = [];
        this.mostrarAviso(
          "Erro!",
          error.response?.data?.message || "Erro ao buscar templates",
          "error",
        );
      } finally {
        this.loadingTemplates = false;
      }
    },

    selectTemplate(template) {
      this.selectedTemplate = template;
      this.selectedTemplateId = template._id;

      const quantidadeParametros = this.extractTemplateParams(
        template.content,
      ).length;

      this.templateParams = new Array(quantidadeParametros).fill("");
      this.templateParamLabels = new Array(quantidadeParametros).fill("");
    },

    onTemplateSelectChange(templateId) {
      if (!templateId) {
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.templateParams = [];
        this.templateParamLabels = [];
        return;
      }

      const template = this.activeTemplates.find(
        (item) => item._id === templateId,
      );

      if (template) {
        this.selectTemplate(template);
      }
    },

    extractTemplateParams(content) {
      if (!content) {
        return [];
      }

      const regex = /\{\{(\d+)\}\}/g;
      const params = [];
      let match;

      while ((match = regex.exec(content)) !== null) {
        params.push(match[1]);
      }

      return [...new Set(params)].sort((a, b) => a - b);
    },

    getTemplatePreview(content) {
      if (!content) {
        return "";
      }

      const parametros = this.extractTemplateParams(content);

      return content.replace(/\{\{(\d+)\}\}/g, (match, numero) => {
        const indiceParametro = parametros.findIndex(
          (parametro) => String(parametro) === String(numero),
        );

        if (indiceParametro < 0) {
          return match;
        }

        const valor = this.templateParams[indiceParametro];

        return valor && String(valor).trim() !== "" ? valor : match;
      });
    },

    getTemplateViewDetalhes(item) {
      if (!this.templateDetalhesContent) {
        return "";
      }

      const parametros = this.extractTemplateParams(
        this.templateDetalhesContent,
      );
      const valores = this.getTemplateParamsDetalhes(item);

      return this.templateDetalhesContent.replace(
        /\{\{(\d+)\}\}/g,
        (match, numero) => {
          const indiceParametro = parametros.findIndex(
            (parametro) => String(parametro) === String(numero),
          );

          if (indiceParametro < 0) {
            return match;
          }

          const valor = valores[indiceParametro];
          return valor && String(valor).trim() !== "" ? valor : match;
        },
      );
    },

    async carregarTemplateDetalhes(item) {
      this.templateDetalhesContent = "";

      if (!item || !item.empresa || !item.templateId) {
        return;
      }

      const telefoneEmpresa = this.getTelefoneEmpresa(item.empresa);
      if (!telefoneEmpresa) {
        return;
      }

      this.loadingTemplateDetalhes = true;

      try {
        const response = await SonaxService.getTemplates(telefoneEmpresa);
        const brokers = response.data?.data?.brokers || [];

        let templates = [];
        brokers.forEach((broker) => {
          if (Array.isArray(broker.templates)) {
            templates = templates.concat(broker.templates);
          }
        });

        const templateEncontrado = templates.find(
          (template) => template._id === item.templateId,
        );

        this.templateDetalhesContent = templateEncontrado?.content || "";
      } catch (error) {
        console.error("Erro ao carregar template dos detalhes:", error);
        this.templateDetalhesContent = "";
      } finally {
        this.loadingTemplateDetalhes = false;
      }
    },

    async enviarMensagemLote() {
      const formularioValido = this.$refs.form.validate();

      if (!formularioValido) {
        return;
      }

      if (!this.selectedTemplateId) {
        this.mostrarAviso(
          "Aviso",
          "Selecione um template antes de realizar o disparo.",
          "warning",
        );
        return;
      }

      if (!this.allParametersFilled) {
        this.mostrarAviso(
          "Aviso",
          "Preencha todos os parametros do template antes de continuar.",
          "warning",
        );
        return;
      }

      this.loadingCreate = true;

      try {
        const dto = {
          empresa: this.mensagem.empresa,
          titulo: this.mensagem.titulo,
          templateId: this.selectedTemplateId,
          templateNome: this.selectedTemplate?.name || "",
          templateParams: [...this.templateParams],
          dataEnvio: this.mensagem.dataEnvio,
          horarioEnvio: this.mensagem.horarioEnvio,
          status: this.mensagem.status,
          finalizarProtocolos: this.mensagem.finalizarProtocolos,
        };
        console.log("DTO a ser enviado:", dto);
        const response = await mensageria.importar_mensageria_lote(
          this.arquivoExcel,
          dto,
        );

        this.mostrarAviso(
          "Sucesso!",
          response.data.message || "Mensagem em lote agendada com sucesso!",
          "success",
        );

        this.limparFormulario();
        this.carregarLista();
      } catch (error) {
        console.error("Erro ao enviar mensagem em lote:", error.response.data);
        this.mostrarAviso(
          "Erro!",
          error.response?.data || "Erro ao enviar mensagem em lote",
          "error",
        );
      } finally {
        this.loadingCreate = false;
      }
    },

    limparFormulario() {
      this.$refs.form.resetValidation();
      
      this.arquivoExcel = null;
      this.templates = [];
      this.selectedTemplate = null;
      this.selectedTemplateId = null;
      this.templateParams = [];
      this.templateParamLabels = [];
      this.mensagem = {
        empresa: null,
        titulo: "",
        dataEnvio: "",
        horarioEnvio: "12:00",
        status: true,
        finalizarProtocolos: true,
      };
      this.inicializarData();
    },

    async carregarLista() {
      this.loadingLista = true;

      try {
        const response = await mensageria.listar_mensagerias_em_lote();
        this.listaMensagensLote = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar lista de mensagens em lote:", error);
        this.mostrarAviso(
          "Erro!",
          "Erro ao carregar lista de mensagens em lote",
          "error",
        );
      } finally {
        this.loadingLista = false;
      }
    },

    async visualizarDetalhes(item) {
      this.loadingDetalhesDialog = true;
      this.loadingResumoStatus = true;
      this.loadingTemplateDetalhes = true;
      try {
        const [detalhesResult, resumoResult] = await Promise.allSettled([
          mensageria.buscar_mensageria_em_lote_por_id(item.id),
          mensageria.buscar_resumo_status_mensageria_em_lote(item.id),
        ]);

        if (detalhesResult.status !== "fulfilled") {
          throw detalhesResult.reason;
        }

        this.mensagemSelecionada = detalhesResult.value.data || {};
        this.resumoStatus = {
          totalClientes: this.quantidadeClientes(this.mensagemSelecionada),
          totalPendentes: 0,
          totalEnviadas: 0,
          totalEntregues: 0,
          totalLidas: 0,
          totalErro: 0,
          ...(resumoResult.status === "fulfilled"
            ? resumoResult.value.data || {}
            : {}),
        };
        await this.carregarTemplateDetalhes(this.mensagemSelecionada);
        this.loadingDetalhesDialog = false;
        this.dialogDetalhes = true;
      } catch (error) {
        console.error("Erro ao buscar detalhes:", error);
        this.templateDetalhesContent = "";
        this.resumoStatus = {
          totalClientes: 0,
          totalPendentes: 0,
          totalEnviadas: 0,
          totalEntregues: 0,
          totalLidas: 0,
          totalErro: 0,
        };
        this.loadingDetalhesDialog = false;
        this.mostrarAviso(
          "Erro!",
          "Erro ao carregar detalhes da mensagem",
          "error",
        );
      } finally {
        this.loadingResumoStatus = false;
        this.loadingTemplateDetalhes = false;
      }
    },

    generatePieChartOptions(labels, colors) {
      return {
        chart: {
          width: 440,
          height: 320,
          type: "pie",
        },
        labels,
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -8,
            },
          },
        },
        colors,
        dataLabels: {
          formatter(val) {
            return [`${val.toFixed(1)}%`];
          },
        },
        legend: {
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },

    async alterarStatus(item) {
      try {
        const novoStatus = !item.status;

        await mensageria.atualizar_status_mensageria_em_lote(
          item.id,
          novoStatus,
        );

        this.carregarLista();

        this.mostrarAviso(
          "Sucesso!",
          `Status alterado para ${novoStatus ? "Ativo" : "Inativo"}`,
          "success",
        );
      } catch (error) {
        console.error("Erro ao alterar status:", error);
        this.mostrarAviso(
          "Erro!",
          "Erro ao alterar status da mensagem",
          "error",
        );
      }
    },

    mostrarAviso(title, message, type = "info") {
      const config = {
        title,
        message,
        color: "primary",
        icon: "mdi-information",
      };

      switch (type) {
        case "success":
          config.color = "success";
          config.icon = "mdi-check-circle";
          break;
        case "error":
          config.color = "error";
          config.icon = "mdi-alert-circle";
          break;
        case "warning":
          config.color = "warning";
          config.icon = "mdi-alert";
          break;
        default:
          config.color = "info";
          config.icon = "mdi-information";
      }

      this.avisoConfig = config;
      this.dialogAviso = true;
    },
  },
};
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-label__required {
  display: inline-flex;
  align-items: center;
  color: #be123c;
  font-size: 0.7rem;
  font-weight: 700;
}

.template-preview-sheet {
  background: #fafcff;
  border-color: rgba(48, 85, 164, 0.2) !important;
}

.template-preview-text {
  white-space: pre-line;
  line-height: 1.6;
  color: #1f2937;
}

.mensageria-lote-file-input >>> .v-input__prepend-outer .v-icon {
  font-size: 28px !important;
  color: green !important;
}

.info-icon {
  font-size: 22px !important;
}

.resumo-status-card {
  border-color: rgba(48, 85, 164, 0.14) !important;
}

.resumo-status-placeholder {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resumo-status-total,
.resumo-status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.resumo-status-item + .resumo-status-item {
  margin-top: 12px;
}

.resumo-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
  margin-right: 10px;
}

.mensageria-lote-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.mensageria-lote-action-btn {
  min-width: 36px !important;
  width: 36px;
  height: 36px !important;
  border-radius: 10px;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.mensageria-lote-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}
</style>
